var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.429199,
    y: 0.640625,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#DEF0E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4294 9.47656C12.4713 9.47656 9.2627 12.6852 9.2627 16.6432C9.2627 20.6013 12.4713 23.8099 16.4294 23.8099C20.3874 23.8099 23.596 20.6013 23.596 16.6432C23.596 12.6852 20.3874 9.47656 16.4294 9.47656Z",
    fill: "#00CE8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7829 13.623C20.9782 13.8183 20.9782 14.1349 20.7829 14.3301L15.4496 19.6634C15.2543 19.8587 14.9377 19.8587 14.7425 19.6634L12.4091 17.3301C12.2139 17.1349 12.2139 16.8183 12.4091 16.623C12.6044 16.4277 12.921 16.4277 13.1162 16.623L15.096 18.6028L20.0758 13.623C20.2711 13.4277 20.5877 13.4277 20.7829 13.623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.6dd741705724cc8208e60047f6c145ca.svg";
export { ForwardRef as ReactComponent };